
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/[...slug]",
      function () {
        return require("private-next-pages/csr/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/[...slug]"])
      });
    }
  